/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


(function(){

    function TextEffect(element){
        var wrapperHeight = 0;

        var words = element.dataset.words.toString().split(',');
        var wrapper = document.createElement("span");
        wrapper.classList.add("teWrapper");
        var scroll = document.createElement("span")
        scroll.classList.add("teScroll");

        var cText = element.innerHTML;

        var text = cText.split(' ').slice(1).join(' ')
        var firstWord = cText.split(' ')[0];
        words.unshift(firstWord);

        words.forEach((word, i) => {
            const span = document.createElement("span");
            span.classList.add("word");
            if(i > 0){
                span.classList.add('teHide');
            }
            span.innerHTML = word.trim() + ' ';
            scroll.appendChild(span);           
        });

        var lenght = words.length;

        wrapper.prepend(scroll);
        element.innerHTML = '&nbsp;' + text;
        element.prepend(wrapper);

        // 
        function setHeight(){
            var a = scroll.getElementsByClassName('word')[0].getBoundingClientRect();
            wrapperHeight = a.height;
            wrapper.style.height = wrapperHeight + "px";
        }
        
        var current = 1;
        function setNext(){
            // Scroll
            scroll.style.transform = "translateY(-" + (wrapperHeight*current) + "px)";

            var children = scroll.children;
            for (var i = 0; i < children.length; i++) {
                var word = children[i];
                if(i == current){
                    word.classList.remove("teHide");
                }else{
                    word.classList.add("teHide");
                }
            }
            current++;

            if(current >= lenght){
                current = 0;
            }
        }
        
        // Throttling Function
        var tfns = {};
        function throttleFunction(name, func, delay){
            clearTimeout(tfns[ name ]);
            tfns[ name ] = setTimeout(func, delay);
        }

        var interval = false;
        function start(){
            if(interval){ clearInterval(interval); }
            interval = setInterval(function(){
                setNext();
            }, 3000);
        }

        window.addEventListener("resize", () => {
            if(interval){ clearInterval(interval); }
            throttleFunction('height', setHeight, 200);
            throttleFunction('next', setNext, 240);
            throttleFunction('interval', start, 240);
        });


        setHeight();
        start();

    }

    var els = document.getElementsByClassName('wp-block-amrita-text-effect-element');
    for (var i = 0; i < els.length; ++i) {
        if (els[i].dataset.TextEffect) { return els[i].dataset.TextEffect; }
        var textEffect = new TextEffect(els[i]);
        els[i].dataset.TextEffect = textEffect;
    }

})();


